<template>
  <component :is="layoutComponent" :field="field" :errors="errors">
    <template slot="field">
      <label class="location-label">
        <vue-google-autocomplete
          v-if="googleLoaded"
          :id="field.attribute + '-address'"
          ref="address"
          classname="form-control"
          :placeholder="field.placeholder"
          :types="geocodeTypes"
          @placechanged="setAddressData"
          @keypress.enter.prevent
        />
      </label>
      <div
        v-if="field.withMap"
        class="mt-2 embed-responsive embed-responsive-16by9"
      >
        <div
          :id="field.attribute + '-map'"
          ref="map"
          class="embed-responsive-item rounded"
        >
          {{ $t("Map is loading ...") }}
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import { FormLocationField } from "stylemix-base";

export default {
  name: "FormCustomLocationField",
  extends: FormLocationField,
};
</script>
